<template>
  <el-dialog title="删除快捷功能" :visible.sync="dialogVisible" width="400px" @close="handleClose">
    <div class="del-dialog-content">
      <i class="el-icon-warning"></i>
      <span>确认删除该快捷功能？</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteQuickMenu } from '@/api/dev/quickMenuApi'

export default {
  name: 'DelQuickMenu',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    async handleConfirm() {
      try {
        await deleteQuickMenu(this.caId)
        this.$message.success('删除成功')
        this.handleClose()
        this.$emit('success')
      } catch (error) {
        console.error('delete quick menu failed', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.del-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.del-dialog-content i {
  font-size: 24px;
  color: #E6A23C;
  margin-right: 10px;
}

.dialog-footer {
  text-align: right;
}
</style>